import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import { FormBuilder } from 'shared-components/forms/form';
import { Modal } from '../elements-modal/modal';
import { FormattedMessage } from 'react-intl';
import _ from 'lodash';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';

export class BookingsRequestModal extends React.Component {
  constructor (props) {
    super(props);

    this.getBannerText = this.getBannerText.bind(this);
    this.getHeaderText = this.getHeaderText.bind(this);
    this.closeBehavior = this.closeBehavior.bind(this);
    this.renderBodySuccessMessage = this.renderBodySuccessMessage.bind(this);
    this.renderBody = this.renderBody.bind(this);
  }

  getBannerText () {
    const isInstantBooking = _.get(this.props, 'booking.is_instant_booking');

    if (isInstantBooking) {
      return 'Your booking is confirmed.';
    }

    return 'Booking request sent';
  }

  getHeaderText () {
    const isInstantBooking = _.get(this.props, 'booking.is_instant_booking');
    const { success, errorHead } = this.props;
    const errSomethingWrong = <FormattedMessage id='web_2.error_page.something_wrong' defaultMessage='Something went wrong'/>;
    const errorHeading = errorHead || errSomethingWrong;

    if (!success) {
      return errorHeading;
    }

    if (isInstantBooking) {
      return 'Need additional services?';
    }

    return 'Need catering? Other services?';
  }

  closeBehavior () {
    const { booking, submitCB, reloadPage } = this.props;
    if (submitCB) { submitCB(booking, true); }
    if (reloadPage && ('undefined' !== typeof window)) {
      return window.location.reload();
    }
    $('#modal-container').modal('hide');
    return ReactDOM.unmountComponentAtNode(document.getElementById('modal-container'));
  }

  renderBodySuccessMessage () {
    const isInstantBooking = _.get(this.props, 'booking.is_instant_booking');

    if (isInstantBooking) {
      return (
        <div>
          <p className="text-left">Let the Peerspace Concierge team arrange catering, furniture, audio visual, or any other services you may need for your booking.</p>
        </div>
      );
    }

    return (
      <div>
        <p className="text-left">Your booking request has been sent. Your host has 2 business days to respond, but most respond much faster than that.</p>
      </div>
    );
  }

  renderBody () {
    const { booking, success, errorMsg, errorHead, duplicateRequest, duplicateBookingId } = this.props;
    const unknownErr = errorHead ? null : errorMsg;
    const guestId = _.get(booking, 'guest_id', '');
    const bookingId = _.get(booking, '_id', '');
    const errFirstPart = unknownErr || <FormattedMessage id="bkc.bookings_request_modal.try_again" defaultMessage="Please try again." />;
    const zendeskLocale = SharedIntlProviderHOC.getZendeskLocale();

    if (success) {
      return (
        <div className="bookings-modal-body">
          { this.renderBodySuccessMessage() }
          <div className="row">
            <div className="col-md-12">
              <button type="button" className="btn btn-link" onClick={this.closeBehavior}>Done</button>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="bookings-modal-body">
        <p>
          {duplicateRequest ?
            <FormattedMessage
              id="bkc.bookings_request_modal.duplicate_body"
              defaultMessage="You can view your pending request in your {inbox}. If you think this is an error, contact our support team {link}."
              values={{
                inbox: <a href={`/inbox/${duplicateBookingId}`} target="_blank"><FormattedMessage
                  id="bkc.bookings_request_modal.inbox"
                  defaultMessage="Inbox"
                /></a>,
                link: (
                  <a target="_blank" className="underline" href={`https://support.peerspace.com/hc/${zendeskLocale}/requests/new`}>
                    <FormattedMessage
                      id="bkc.bookings_request_modal.here"
                      defaultMessage="here"
                    />
                  </a>
                )
              }}
            />
            :
            <FormattedMessage
              id="bkc.bookings_request_modal.contact_us"
              defaultMessage="{firstPart} More information about the likely cause for this error can be found in our {supportLink}."
              values={{
                firstPart: errFirstPart,
                supportLink: <a href="https://support.peerspace.com/hc/articles/360031059811-Why-did-my-credit-card-get-declined-" target="_blank" rel="noopener noreferrer" className="underline"> <FormattedMessage id='bkc.bookings_request_modal.support_link' defaultMessage='support center' /></a>
              }}
            />}
        </p>
        <FormBuilder
          ref="bookingsFailure"
          formname="msg host form"
          formStyle="modal"
          formInputs={[]}
          submitAction={this.closeBehavior}
          buttonText="Okay"
          buttonClass= "btn btn-primary"
        />
      </div>
    );
  }

  render () {
    const { success } = this.props;
    const bannerText = this.getBannerText();
    const headerText = this.getHeaderText();

    const bannerHTML = () => {
      return (
        <div className="text-white">
          <i className="ico ico-md icon-yes" />
          <span>{bannerText}</span>
        </div>
      );
    };

    const banner = {
      type: 'booking-success',
      text: bannerHTML()
    };

    return (<Modal
      show
      banner={success ? banner : null}
      allowClickAway={!success}
      addCloseIcon={false}
      modalID="bookings-request-modal"
      modalSize="sm-size"
      body={this.renderBody()}
      header={headerText}
      closeBehavior={this.closeBehavior}
      footer={null}
    />);
  }
}

BookingsRequestModal.propTypes = {
  success: PropTypes.bool.isRequired,
  booking: PropTypes.object,
  errorMsg: PropTypes.string,
  errorHead: PropTypes.string,
  submitCB: PropTypes.func,
  reloadPage: PropTypes.bool
};
